// extracted by mini-css-extract-plugin
export default {"SystemMessageContainer":"SystemMessage_SystemMessageContainer__+obnx","SystemMessage":"SystemMessage_SystemMessage__8o7N9"};